import { Bell, Search, Settings as SettingsIcon } from 'lucide-react';
import { useLocation, useNavigate } from 'react-router-dom';

const TITLES: Record<string, string> = {
  '/': 'Dashboard',
  '/projects': '專案列表',
  '/projects/new': '新增專案',
  '/organizers': '整理師列表',
  '/payments': '金流付款',
  '/feedback': '回饋處理',
  '/access-requests': 'LINE 登入審核',
  '/settings': '系統設定',
};

export function Topbar() {
  const location = useLocation();
  const navigate = useNavigate();

  let current = TITLES[location.pathname];
  if (!current && location.pathname.startsWith('/projects/')) {
    current = location.pathname.includes('/edit') ? '報價編輯器' : '專案詳細';
  }
  if (!current) current = '頁面';

  return (
    <header className="bg-white border-b border-slate-200 px-4 md:px-7 py-3 flex items-center gap-5 sticky top-0 z-30">
      {/* Breadcrumb */}
      <div className="flex items-center gap-1.5 text-[13px] text-slate-500 min-w-0">
        <span className="hidden sm:inline">漾丰國際</span>
        <span className="hidden sm:inline text-slate-300">/</span>
        <span className="font-semibold text-slate-900 truncate">{current}</span>
      </div>

      <div className="ml-auto flex items-center gap-2">
        <div className="hidden lg:flex items-center gap-1.5 bg-slate-50 border border-slate-200 rounded-md px-3 py-1.5 w-[280px]">
          <Search size={15} className="text-slate-400" />
          <input
            type="text"
            placeholder="搜尋案件、客戶、整理師..."
            className="border-none outline-none bg-transparent flex-1 text-[13px]"
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                navigate(`/projects?search=${encodeURIComponent((e.target as HTMLInputElement).value)}`);
              }
            }}
          />
          <span className="text-[11px] text-slate-400 px-1.5 py-px bg-white rounded border border-slate-200">⌘K</span>
        </div>

        <button className="w-8.5 h-8.5 w-[34px] h-[34px] rounded-md border border-slate-200 bg-white flex items-center justify-center text-slate-600 hover:bg-slate-50 relative">
          <Bell size={15} />
          <span className="absolute top-1.5 right-1.5 w-1.5 h-1.5 bg-red-500 rounded-full" />
        </button>
        <button
          onClick={() => navigate('/settings')}
          className="w-[34px] h-[34px] rounded-md border border-slate-200 bg-white flex items-center justify-center text-slate-600 hover:bg-slate-50"
        >
          <SettingsIcon size={15} />
        </button>
      </div>
    </header>
  );
}
